import { app } from '../../../../../app';
import { Controller } from './subscription-info.controller';

app.component('subscriptionInfo', {
    bindings: {
        licenseInfo: '<',
        currentPlan: '<',
        licenseTiers: '<',
    },
    controller: Controller,
    templateUrl: require('./subscription-info.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/current-plan/subscription-info/subscription-info.component.js